import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "test") {
      return;
    }

    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
